<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M7.3 3V2h1.383v1H7.3Zm0 11v-1h1.383v1H7.3ZM4.467 3V2H5.85v1H4.467Zm0 11v-1H5.85v1H4.467ZM2 3V2h1v1H2Zm0 11v-1h1v1H2Zm8.15 0V2H14v12h-3.85ZM8.683 8 6.25 5.567l-.7.7L6.767 7.5H2v1h4.767L5.55 9.733l.7.7L8.683 8Z"
        />
    </svg>
</template>

<script setup lang="ts">
type InsertRightFilledIconProps = {
    ariaLabelledby?: string;
};
const props = defineProps<InsertRightFilledIconProps>();
</script>
